import { Box } from '@chakra-ui/react'
import React from 'react'

const AdminWelcome = () => {
  return (
  <Box w={'80%'} ml={'20%'}  h={'100vh'}display={'flex'} alignItems={'center'} justifyContent={'center'} fontSize={'2.5rem'} fontWeight={'bold'}>
     Welcome
  </Box>
  )
}

export default AdminWelcome
